import React from 'react';
import { ShieldCheckIcon, StethoscopeIcon } from 'lucide-react';
export function VetConnect() {
  return <section aria-labelledby="vet-titre" className="mt-10 flex flex-wrap items-center gap-5 rounded-3xl border border-slate-200 bg-slate-50 p-6" data-id="element-267" data-mp="nhcw581dys8d">
      <span className="grid h-12 w-12 shrink-0 place-items-center rounded-2xl bg-white text-ville-indigo" aria-hidden="true" data-id="element-268" data-mp="wag26v9pc2sz">
        <StethoscopeIcon className="h-6 w-6" data-id="element-269" data-mp="11ac7qyy1s2an" />
      </span>
      <div className="min-w-0 flex-1" data-id="element-270" data-mp="11bx2opo9xn91">
        <h2 id="vet-titre" className="text-[15px] font-extrabold text-ville-navy" data-id="element-271" data-mp="167ujsy7d2xmv">
          Services vétérinaires — Vet&amp;Cie
        </h2>
        <p className="mt-1 text-sm leading-relaxed text-slate-600" data-id="element-272" data-mp="1b8i6x8sgyubt">
          Connectez votre animal à votre clinique avec votre consentement. Vous choisissez quel animal et quelles
          informations sont partagées.
        </p>
        <p className="mt-2 flex items-center gap-1.5 text-xs text-slate-500" data-id="element-273" data-mp="3h0owmicl20wj">
          <ShieldCheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-274" data-mp="3h2rqjdguwe6j" />
          Aucune information de santé n’est partagée automatiquement.
        </p>
      </div>
      <button type="button" className="rounded-full border border-ville-navy px-5 py-2.5 text-sm font-bold text-ville-navy transition-colors duration-150 ease-ville hover:bg-ville-navy hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo focus-visible:ring-offset-2" data-id="element-275" data-mp="3h97fb0108xit">
        Connecter Vet&amp;Cie
      </button>
    </section>;
}